import { render, staticRenderFns } from "./QuestionnaireEditModule.vue?vue&type=template&id=a70672d6"
import script from "./QuestionnaireEditModule.vue?vue&type=script&lang=js"
export * from "./QuestionnaireEditModule.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireEditModule.vue?vue&type=style&index=0&id=a70672d6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports